import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Descriptions, Divider, Tag, Button, Row, Col, List, Modal, Card, Collapse, Typography } from 'antd'
import { EditOutlined, DeleteOutlined, PlusOutlined, MedicineBoxOutlined, UserOutlined, FolderOutlined } from '@ant-design/icons';
import { checkPermission } from '@/utils/permission';
import { isValidDate } from '@/utils/helpers';
import ServicesInterestedForm from '../customer-services/ServicesInterestedForm';
import HtmlParser from 'react-html-parser';
// actions
import { getSpecificService, removeService } from '@/redux/actions/CustomerServicesActions';
import ExpandableText from '@/components/ExpandableText';

const { confirm } = Modal;
const { Panel } = Collapse;
const { Text } = Typography;

class ServicesInterestedList extends Component {
    constructor() {
        super();
        this.state = {
            isOpenForm: false,
            currentData: null
        };
    }

    handleCancel() {
        this.props.onCancel();
    }

    toggleOpenForm(isOpenForm, currentData = null) {
        this.setState({
            isOpenForm: isOpenForm,
            currentData: currentData,
            currentCustomer: this.props.currentItem
        });
    }

    onEdit(id) {
        this.props.getSpecificService(id).then(res => {
            this.toggleOpenForm(true, res);
        })
    }

    openRemove(id) {
        confirm({
            title: 'Cảnh báo',
            content: 'Bạn chắc chắn muốn xoá bản ghi này?',
            okText: 'OK',
            cancelText: 'Huỷ',
            onOk: () => this.props.removeService(id).then(() => {
                setTimeout(() => {
                    this.props.reloadData();
                    Modal.destroyAll();
                }, 800);
            }),
            onCancel() { },
        })
    }

    render() {
        var { currentData,
            isOpenForm,
            currentCustomer } = this.state;
        var { currentItem } = this.props;

        return (
            <div>
                {
                    checkPermission('customer_services', 'list') ? (
                        <>
                            {/* <Divider orientation="left" orientationMargin="0" className='mt-4 mb-0'>
                                <Tag color='#0b2b33'>4</Tag> Dịch vụ quan tâm
                            </Divider> */}
                            <Row justify="end" className='mb-1'>
                                <Button disabled={!checkPermission('customer_services', 'create')} type="dashed" className='color-blue' size='small' onClick={() => this.toggleOpenForm(true)} icon={<PlusOutlined />}>Thêm mới</Button>
                            </Row>
                            {currentItem.services_interested && currentItem.services_interested.length > 0 ? (
                                <Row gutter={16}>
                                    {currentItem.services_interested.map((item, index) => {
                                        return (
                                            <Col key={index} xs={24} md={12} lg={8} className='box-item-service customer-info-data mb-3'>
                                                <Card size="small"
                                                    title={<>{<MedicineBoxOutlined />} {item.service_name}</>}
                                                    style={{ background: '#e7efea' }}
                                                    extra={
                                                        <>
                                                            {checkPermission('customer_services', 'update') ? (
                                                                <a onClick={() => this.onEdit(item.id)} type="link" key="list-vertical-edit">
                                                                    <EditOutlined /> Sửa
                                                                </a>
                                                            ) : null}

                                                            {checkPermission('customer_services', 'remove') ? (
                                                                <>
                                                                    <Divider type='vertical' />
                                                                    <span className='delete-icon' onClick={() => this.openRemove([item.id])} type="link" key="list-vertical-delete">
                                                                        <DeleteOutlined /> Xóa
                                                                    </span>
                                                                </>
                                                            ) : null}
                                                        </>
                                                    }
                                                >
                                                    <Row gutter={16} className='customer-service-box'>
                                                        <Col xs={24} md={24}>
                                                            <Collapse
                                                                expandIconPosition="end"
                                                                ghost
                                                                defaultActiveKey={[]}
                                                            >
                                                                <Panel
                                                                    header={<><span className="font-weight-500"><UserOutlined /> Nhân viên tư vấn</span></>}
                                                                    key="1"
                                                                >
                                                                    {
                                                                        item?.consultant && item?.consultant.length ? (
                                                                            <>
                                                                                <Row gutter={16}>
                                                                                    {
                                                                                        item?.consultant.map((item2, index2) => {
                                                                                            return (
                                                                                                <div key={index2} style={{ borderBottom: '1px solid #dedede' }} className='mb-2 pb-2'>
                                                                                                    <Col xs={24} md={24}>
                                                                                                        <Descriptions size="small">
                                                                                                            <Descriptions.Item label="Nhân viên">
                                                                                                                {item2.consultant_user}
                                                                                                            </Descriptions.Item>
                                                                                                        </Descriptions>
                                                                                                    </Col>
                                                                                                    <Col xs={24} md={24}>
                                                                                                        <Descriptions size="small">
                                                                                                            <Descriptions.Item label="Thời điểm">
                                                                                                                {isValidDate(item2.consultant_date)}
                                                                                                            </Descriptions.Item>
                                                                                                        </Descriptions>
                                                                                                    </Col>
                                                                                                    <Col xs={24} md={24}>
                                                                                                        <div className="font-weight-500">Kết quả tư vấn:</div>
                                                                                                        {HtmlParser(item2.note)}
                                                                                                    </Col>
                                                                                                </div>
                                                                                            )
                                                                                        })
                                                                                    }
                                                                                </Row>
                                                                            </>) : (
                                                                            <Row gutter={16}><div style={{ textAlign: 'center', width: '100%' }} className='no-data'>Chưa có dữ liệu</div></Row>
                                                                        )
                                                                    }
                                                                </Panel>
                                                            </Collapse>
                                                        </Col>
                                                    </Row>
                                                    <Row gutter={16} className='mt-2'>
                                                        <Col xs={24} md={24}>
                                                            <Text strong>Tình trạng hiện tại: </Text>
                                                            <ExpandableText
                                                                text={item.current_status}
                                                                rows={1}
                                                            />
                                                            <Divider className='no-margin' />
                                                        </Col>
                                                    </Row>
                                                    <Row gutter={16} className='mt-2'>
                                                        <Col xs={24} md={24}>
                                                            <Text strong>Kết quả tư vấn: </Text>
                                                            <ExpandableText
                                                                text={item.note}
                                                                rows={1}
                                                            />
                                                        </Col>
                                                    </Row>
                                                </Card>
                                            </Col>
                                        )
                                    })}
                                </Row>
                            ) : null}


                            {/* <Row gutter={16}>
                                <Col xs={24} md={24}>
                                    <List
                                        className='list-in-detail-customer dv-quan-tam'
                                        itemLayout="vertical"
                                        rowKey='id'
                                        size="small"
                                        locale={{ emptyText: "Chưa có dữ liệu" }}
                                        dataSource={currentItem.services_interested || []}
                                        renderItem={(item, index) => {
                                            const IconAction = [];
                                            if (checkPermission('customer_services', 'update')) {
                                                IconAction.push(<a onClick={() => this.onEdit(item.id)} type='link' key="list-vertical-edit"><EditOutlined /> Sửa</a>)
                                            }
                                            if (checkPermission('customer_services', 'remove')) {
                                                IconAction.push(<span className='delete-icon' onClick={() => this.openRemove([item.id])} type='link' key="list-vertical-delete"><DeleteOutlined /> Xóa</span>)
                                            }

                                            return (
                                                <List.Item
                                                    key={index}
                                                    actions={IconAction}
                                                    className='mb-3'
                                                    locale={{ emptyText: "Chưa có dữ liệu" }}
                                                >
                                                    <List.Item.Meta
                                                        title={<><MedicineBoxOutlined /> {item.service_name}</>}
                                                        className='mb-0'
                                                    />
                                                    <Row gutter={16}>
                                                        <Col xs={24} md={24}>
                                                            <Descriptions size="small">
                                                                <Descriptions.Item label="Tình trạng hiện tại">
                                                                    {item.current_status}
                                                                </Descriptions.Item>
                                                            </Descriptions>
                                                        </Col>
                                                        <Col xs={24} md={24}>
                                                            <Descriptions size="small">
                                                                <Descriptions.Item label="Ghi chú">
                                                                    {HtmlParser(item.note)}
                                                                </Descriptions.Item>
                                                            </Descriptions>
                                                        </Col>
                                                    </Row>
                                                    {
                                                        item?.consultant && item?.consultant.length ? (
                                                            <>
                                                                <h6 className='h6-title'>Nhân viên tư vấn online:</h6>
                                                                <Row gutter={16}>
                                                                    {
                                                                        item?.consultant.map(item2 => {
                                                                            return (
                                                                                <Col xs={24} md={12} className='mb-2'>
                                                                                    <Card size="small" className='card-service-detail'>
                                                                                        <Col xs={24} md={24}>
                                                                                            <Descriptions size="small">
                                                                                                <Descriptions.Item label="Nhân viên">
                                                                                                    {item2.consultant_user}
                                                                                                </Descriptions.Item>
                                                                                            </Descriptions>
                                                                                        </Col>
                                                                                        <Col xs={24} md={24}>
                                                                                            <Descriptions size="small">
                                                                                                <Descriptions.Item label="Thời điểm">
                                                                                                    {isValidDate(item2.consultant_date)}
                                                                                                </Descriptions.Item>
                                                                                            </Descriptions>
                                                                                        </Col>
                                                                                        <Col xs={24} md={24}>
                                                                                            <h6 className="h6-title">Kết quả tư vấn:</h6>
                                                                                            {HtmlParser(item2.note)}
                                                                                        </Col>
                                                                                    </Card>
                                                                                </Col>
                                                                            )
                                                                        })
                                                                    }
                                                                </Row>
                                                            </>) : null
                                                    }
                                                </List.Item>
                                            )
                                        }}
                                    />
                                </Col>
                            </Row> */}
                        </>
                    ) : null
                }
                <ServicesInterestedForm
                    visible={isOpenForm}
                    currentItem={currentData}
                    currentCustomer={currentCustomer}
                    reloadData={() => this.props.reloadData()}
                    onCancel={() => this.toggleOpenForm(false)}
                />
            </div >
        )
    }
}
function mapStateToProps(state) {
    return {
        authUser: state.auth.authUser,
        branchActiveList: state.BranchReducer.branchActiveList
    }
}

function mapDispatchToProps(dispatch) {
    return {
        removeService: (ids) => dispatch(removeService(ids)),
        getSpecificService: (id) => dispatch(getSpecificService(id))
    }
}

// export default connect(mapStateToProps, mapDispatchToProps)(ServicesInterestedList);

// Sử dụng forwardRef để truyền ref xuống component
// Mục đích để cho parent component có thể gọi method của child component
const ConnectedCustomerServicesInterestedList = connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { forwardRef: true }
)(ServicesInterestedList);

export default React.forwardRef((props, ref) => (
    <ConnectedCustomerServicesInterestedList {...props} ref={ref} />
));